<template>
  <div class="row mx-0">
    <div class="col-12 alert-notification" :class="color">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
const props = defineProps({
  type: {
    type: String,
    default: 'primary',
  },
});

const types = ref(['primary', 'warning', 'error', 'success']);

const color = computed(() => {
  return types.value.includes(props.type) ? props.type : 'primary';
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/main.scss';

.alert-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 38px;
  border-radius: 10px;

  > img,
  > svg {
    width: 14px;
    height: 14px;
  }

  > span {
    font-size: 14px;

    @media screen and (max-width: map.get(main.$grid-breakpoints, 'sm')) {
      font-size: 10px;
    }
  }

  &.primary {
    background: main.$grey-100_01;
    color: main.$color-primary_01;
  }

  &.warning {
    background: main.$yellow-101;
    color: main.$yellow-400;
  }

  &.error {
    background: main.$yellow-102;
    color: main.$red-500_03;
  }

  &.success {
    color: main.$green-400;
    background: main.$green-101;
  }
}
</style>
